import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./context/AuthContext";

import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import ScanPage from "./pages/ScanPage";
import ScanResultPage from "./pages/ScanResultPage";
import PhishingPage from "./pages/PhishingPage";
import HistoryPage from "./pages/HistoryPage";
import UpgradePage from "./pages/UpgradePage";
import LandingPage from "./pages/LandingPage";
import HelpPage from "./pages/HelpPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

import Layout from "./components/Layout";
import VerifyEmailPage from "./pages/VerifyEmailPage";

/* ───────────────── PRIVATE ROUTE ───────────────── */

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-sky-500 border-t-transparent rounded-full" />
      </div>
    );
  }

  return user ? children : <Navigate to="/login" replace />;
};

/* ───────────────── PUBLIC ROUTE ───────────────── */

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  return user ? <Navigate to="/dashboard" replace /> : children;
};

/* ───────────────── ROUTES ───────────────── */

function AppRoutes() {
  return (
    <Routes>

      {/* Landing Page */}
      <Route path="/" element={<LandingPage />} />

      {/* Public Routes */}

      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />

      <Route
        path="/register"
        element={
          <PublicRoute>
            <RegisterPage />
          </PublicRoute>
        }
      />

      <Route
      path="/verify-email/:token"
      element={
          <VerifyEmailPage />
      }
      />

      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgotPasswordPage />
          </PublicRoute>
        }
        />

        <Route
        path="/reset-password/:token"
        element={
          <PublicRoute>
            <ResetPasswordPage />
          </PublicRoute>
        }
      />

      {/* Protected App Layout */}

      <Route
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >

        <Route path="/dashboard" element={<DashboardPage />} />

        <Route path="/scan" element={<ScanPage />} />

        <Route path="/scan/:scanId" element={<ScanResultPage />} />

        <Route path="/phishing" element={<PhishingPage />} />

        <Route path="/history" element={<HistoryPage />} />

        <Route path="/upgrade" element={<UpgradePage />} />

        <Route path="/help" element={<HelpPage />} />

      </Route>

      {/* Fallback */}

      <Route path="*" element={<Navigate to="/" replace />} />

    </Routes>
  );
}

/* ───────────────── APP ROOT ───────────────── */

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>

        <AppRoutes />

        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#1e293b",
              color: "#f1f5f9",
              border: "1px solid #334155",
            },
          }}
        />

      </BrowserRouter>
    </AuthProvider>
  );
}